define((require) => {
    "use strict";

    var Marionette          = require("marionette");

    // Marionette always append newly added view to the end, so we overwrite it here to respect the
    // index of newly added view. This implementation only works when the child item views in the
    // CollectionView all have the same class name.
    // https://github.com/marionettejs/backbone.marionette/blob/v2.0.0/src/marionette.collectionview.js#L371
    Marionette.CollectionView.prototype.appendHtml = function(collectionView, itemView, index) {
        var $elem = collectionView.$el;

        if (collectionView.isBuffering) {
            collectionView.elBuffer.appendChild(itemView.el);
        } else {
            var classFilter = itemView.className ? "." + itemView.className : "",
                children = $elem.children(classFilter);

            if (index >= 0 && children.length) {
                if (index === 0) {
                    children.eq(0).before(itemView.el);
                } else {
                    children.eq(Math.min(index - 1, children.length - 1)).after(itemView.el);
                }
            } else {
                $elem.append(itemView.el);
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/zbone/CollectionView.js